import React from "react";
import { Fade } from "react-awesome-reveal";
import Whats from "./Whats";
import "../styles/Services.scss";
import img1 from "../images/services/1.png";
import img2 from "../images/services/2.png";
import img3 from "../images/services/3.png";
import img4 from "../images/services/4.png";
import img5 from "../images/services/5.png";
import img6 from "../images/services/6.png";
import img7 from "../images/services/7.png";
import img8 from "../images/services/8.png";
import img9 from "../images/services/9.png";
import img10 from "../images/services/10.png";


const Services = () => {
  const servicios = [
    {
      id: 1,
      imagen: img1,
      titulo: "Lavado de vidrios de altura",
      texto:
        'Servicio especializado que realizamos con los más altos estándares de seguridad y calidad. Contamos con equipos avanzados y personal altamente capacitado para limpiar vidrios en edificios de varias alturas, garantizando resultados impecables sin comprometer la seguridad de los operarios ni la estructura del inmueble. Utilizamos técnicas innovadoras que permiten un lavado eficiente y duradero, eliminando la suciedad acumulada, manchas difíciles y restos de polvo. Este servicio es ideal para oficinas, edificios corporativos, centros comerciales y cualquier estructura que requiera mantenimiento en sus ventanas o fachadas de vidrio.',
    },
    {
      id: 2,
      imagen: img2,
      titulo: "Lavado y desinfección de sanitarios",
      texto:
        "El lavado y desinfección de sanitarios es un servicio esencial para mantener la higiene y la salud en espacios comerciales y residenciales. Nuestro equipo utiliza productos especializados y técnicas de limpieza profundas para garantizar que los sanitarios queden completamente libres de bacterias, gérmenes y malos olores. Realizamos una limpieza exhaustiva, incluyendo el desinfectado de superficies, grifos, inodoros, y lavabos, asegurando un ambiente seguro y saludable para todos. Este servicio es ideal para oficinas, centros comerciales, restaurantes, y hogares que buscan un mantenimiento constante y de alta calidad en sus instalaciones sanitarias.",
    },
    {
      id: 3,
      imagen: img3,
      titulo: "Desengrasado de cocinas industriales",
      texto:
        "El desengrasado de cocinas industriales es un servicio especializado diseñado para eliminar de manera efectiva la grasa acumulada en equipos, superficies y áreas de trabajo. Nuestro equipo utiliza productos y técnicas de limpieza profunda para garantizar que las cocinas industriales, restaurantes y establecimientos de comida mantengan altos estándares de higiene y seguridad. Nos encargamos de limpiar campanas extractoras, freidoras, estufas, pisos y más, eliminando la grasa y residuos que pueden afectar tanto el rendimiento de los equipos como la salud del entorno. Con nuestro servicio de desengrasado, aseguramos que su cocina industrial opere de manera eficiente, segura y libre de contaminantes.",
    },
    {
      id: 4,
      imagen: img4,
      titulo: "Lavado de techos, ductos y paredes",
      texto:
        "Servicio esencial para mantener la limpieza y el buen estado de las instalaciones en entornos industriales, comerciales y residenciales. Utilizamos equipos especializados y productos de alta calidad para eliminar polvo, suciedad, manchas y residuos acumulados en superficies de difícil acceso. Nuestro equipo se encarga de limpiar a fondo techos, ductos de ventilación, paredes y cualquier otra área que requiera atención, asegurando un ambiente más saludable, seguro y estéticamente agradable. Este servicio es ideal para oficinas, fábricas, almacenes y edificios que necesitan un mantenimiento exhaustivo de sus instalaciones.",
    },
    {
      id: 5,
      imagen: img5,
      titulo: "Lavado y desengrasado de estacionamientos",
      texto:
        "Servicio clave para mantener estos espacios limpios, seguros y en excelente estado. Con el paso del tiempo, los estacionamientos acumulan grasa, aceite y suciedad que no solo afectan su aspecto, sino también la seguridad de los usuarios y la durabilidad de las superficies. Con nuestro servicio, garantizamos una limpieza profunda utilizando productos de alta calidad y equipos especializados. Eliminamos eficazmente las manchas de grasa y aceite, lavamos las superficies de concreto, asfalto y otros materiales, y desinfectamos áreas de contacto frecuente. Además de mejorar la estética del lugar, también ayudamos a prevenir daños a largo plazo, evitando el desgaste acelerado de las superficies.",
    },
    {
      id: 6,
      imagen: img6,
      titulo: "Lavado y encerado de pisos",
      texto:
        "El lavado y encerado de pisos es esencial para mantener la apariencia y durabilidad de los pisos en cualquier tipo de espacio, ya sea en oficinas, comercios o residencias. Con el tiempo, los pisos acumulan suciedad, manchas y desgaste, lo que puede afectar su aspecto y hacer que pierdan su brillo natural. Nuestro servicio de lavado y encerado utiliza productos de alta calidad y técnicas especializadas para limpiar profundamente las superficies, eliminando la suciedad y restaurando su brillo original. Además, aplicamos una capa de cera protectora que no solo mejora la apariencia de los pisos, sino que también los protege de futuros daños y desgaste. Ya sea para pisos de madera, cerámica, concreto o cualquier otro material, nuestro servicio garantiza resultados duraderos y un entorno más limpio y estéticamente agradable.",
    },
    {
      id: 7,
      imagen: img7,
      titulo: "Limpieza final por remodelación, incendio, inundación, remodelación o terminación de obra.",
      texto:
        "Servicio esencial para dejar cualquier espacio en condiciones óptimas después de una intervención importante. Ya sea que hayas realizado una remodelación, sufrido un incendio o inundación, o finalizado una obra, es necesario realizar una limpieza exhaustiva para eliminar escombros, polvo, manchas y restos de materiales de construcción. Nuestro equipo especializado utiliza equipos y productos de alta calidad para limpiar de manera efectiva todas las superficies, asegurando que el espacio quede listo para su uso, libre de residuos y peligros. Nos encargamos de la limpieza de pisos, paredes, ventanas, techos y cualquier otra área afectada, restaurando la higiene y el orden de manera rápida y segura.",
    },
    {
      id: 8,
      imagen: img8,
      titulo: "Jardinería",
      texto:
        "Brindamos un servicio integral para el cuidado y embellecimiento de sus áreas verdes. Nos encargamos del mantenimiento de plantas, macetones, podas de árboles, reforestación de macetas y jardineras, entre otros servicios especializados. Además, ofrecemos control fitosanitario para asegurar la salud y conservación de sus espacios verdes, manteniéndolos siempre en óptimas condiciones.",
    },
    {
      id: 9,
      imagen: img9,
      titulo: "Control y Exterminio de Plagas",
      texto:
        "Protege tu hogar, oficina o empresa con nuestros servicios profesionales de control de plagas. Nos especializamos en la eliminación y prevención de todo tipo de organismos no deseados, como insectos, roedores y otras plagas que puedan poner en riesgo la higiene y seguridad de tus espacios. Aplicamos métodos eficaces, utilizando productos de calidad y tecnología avanzada, siempre respetando la normativa sanitaria vigente. Nuestro equipo de expertos está capacitado para ofrecerte un servicio rápido, eficiente y adaptado a tus necesidades. Cuidar la salud de tu familia y colaboradores es una prioridad. Por eso, trabajamos para mantener tus instalaciones libres de plagas, evitando daños materiales y problemas de salud asociados. ",
    },
    {
      id: 10,
      imagen: img10,
      titulo: "Desinfección y Sanitización",
      texto:
        "Protege tus espacios con nuestros servicios profesionales de desinfección. Eliminamos eficazmente bacterias, hongos, virus (incluido el COVID-19) y otros gérmenes, asegurando un ambiente seguro y saludable. Atendemos hogares y empresas de sectores industrial, comercial y alimenticio, cumpliendo con las normas sanitarias vigentes y cuidando la salud de tus clientes, colaboradores y familia. Usamos productos certificados y tecnología avanzada para una sanitización profunda y efectiva.",
    },
  ];

  return (
    <div id="allServices" className="mt-2">
      <br/><h4 className="fw-bold fs-3 title">NUESTROS SERVICIOS</h4>
      {servicios.map((servicio) => (
        <section
          className="cursosContainer mt-4 mb-4"
          id={"servicio" + servicio.id}
          key={servicio.id}
        >
          <div className="imgContainer text-center">
            <Fade duration="1000">
              <img src={servicio.imagen} alt={servicio.titulo} />
            </Fade>
          </div>
          <div className="infoCursoContainer">
            <Fade duration="1000">
              <span id={"titleService" + servicio.id} className="titleService">
                <strong>{servicio.titulo}</strong>
              </span>
            </Fade>
            <span id={"textService" + servicio.id} className="textService">{servicio.texto}</span>

            <div className="btnServiceContainer">
              <Whats
                classStyle="btn btnService"
                phoneNumber="5218131053905"
                message={`¡Me pudiera brindar más información acerca de ${servicio.titulo}!`}
                text="¡Más información!"
              />
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default Services;
